import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const info = 'stop-exit_discount';

export const useStopExitPopupAnalytics = () => {
  const trackStopExitPopupShow = useCallback(() => {
    TrackingApi.trackPopup({
      info,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackStopExitPopupClose = useCallback(() => {
    TrackingApi.trackPopup({
      info,
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackStopExitPopupClick = useCallback(() => {
    TrackingApi.trackPopup({
      info,
      operation: 'click',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackStopExitPopupShow,
    trackStopExitPopupClose,
    trackStopExitPopupClick,
  };
};
